import { Grid } from '@mui/material'
import dayjs, { Dayjs } from 'dayjs'
import { FormikProps } from 'formik'
import {
  Button,
  DateTimePicker,
  NumberField,
  TextField,
} from 'shared/components'
import { UpdateRuleManagementRequestModel } from 'types/rule-managements'

interface IEditFormProps {
  formik: FormikProps<UpdateRuleManagementRequestModel>
  onBack: () => void
  isSubmiting?: boolean
}

const EditForm = ({ formik, onBack, isSubmiting = false }: IEditFormProps) => {
  const {
    handleBlur,
    handleChange,
    touched,
    errors,
    submitForm,
    initialValues,
    setFieldValue,
  } = formik || {}

  const onStartGiftChange = (value: Dayjs | null) => {
    setFieldValue('giftStartTime', value)
  }

  const onEndGiftChange = (value: Dayjs | null) => {
    setFieldValue('giftEndTime', value)
  }
  const onStartTemChange = (value: Dayjs | null) => {
    setFieldValue('temStartTime', value)
  }
  const onEndTemChange = (value: Dayjs | null) => {
    setFieldValue('temEndTime', value)
  }

  return (
    <Grid spacing={2} container>
      <Grid item xs={3}>
        <TextField
          type="text"
          name="ruleName"
          key={initialValues.ruleName}
          defaultValue={initialValues.ruleName}
          label="Tên quy tắc"
          onChange={handleChange}
          onBlur={handleBlur}
          error={!!errors.ruleName && touched.ruleName}
          helperText={
            !!errors.ruleName && touched.ruleName ? errors.ruleName : ''
          }
        />
      </Grid>
      <Grid item xs={3}>
        <NumberField
          onChange={handleChange}
          fullWidth
          onBlur={handleBlur}
          error={!!errors.temQuantity && touched.temQuantity}
          helperText={
            !!errors.temQuantity && touched.temQuantity
              ? errors.temQuantity
              : ''
          }
          name="temQuantity"
          label="Số lượng tem"
          defaultValue={initialValues?.temQuantity}
          key={initialValues?.temQuantity}
        />
      </Grid>
      <Grid item xs={3}>
        <NumberField
          onChange={handleChange}
          fullWidth
          onBlur={handleBlur}
          error={!!errors.totalBill && touched.totalBill}
          helperText={
            !!errors.totalBill && touched.totalBill ? errors.totalBill : ''
          }
          name="totalBill"
          label="Giá trị hóa đơn từ"
          defaultValue={initialValues?.totalBill}
          key={initialValues?.totalBill}
        />
      </Grid>
      <Grid item xs={3}>
        <NumberField
          onChange={handleChange}
          fullWidth
          onBlur={handleBlur}
          error={!!errors.totalBillTo && touched.totalBillTo}
          helperText={
            !!errors.totalBillTo && touched.totalBillTo
              ? errors.totalBillTo
              : ''
          }
          name="totalBillTo"
          label="Giá trị hóa đơn đến"
          defaultValue={initialValues?.totalBillTo}
          key={initialValues?.totalBillTo}
        />
      </Grid>
      <Grid item xs={6}>
        <DateTimePicker
          onChange={onStartTemChange}
          helperText={
            touched.temStartTime && !!errors?.temStartTime
              ? errors?.temStartTime
              : ''
          }
          label="Ngày bắt đầu tem"
          defaultValue={dayjs(initialValues.temStartTime)}
          key={initialValues.temStartTime}
        />
      </Grid>
      <Grid item xs={6}>
        <DateTimePicker
          onChange={onEndTemChange}
          helperText={
            touched.temEndTime && !!errors?.temEndTime ? errors?.temEndTime : ''
          }
          label="Ngày kết thúc tem"
          defaultValue={dayjs(initialValues.temEndTime)}
          key={initialValues.temEndTime}
        />
      </Grid>
      <Grid item xs={6}>
        <DateTimePicker
          onChange={onStartGiftChange}
          helperText={
            !!errors?.giftStartTime && touched.giftStartTime
              ? errors?.giftStartTime
              : ''
          }
          defaultValue={dayjs(initialValues.giftStartTime)}
          key={initialValues.giftStartTime}
          label="Ngày bắt đầu quà tặng"
        />
      </Grid>
      <Grid item xs={6}>
        <DateTimePicker
          defaultValue={dayjs(initialValues.giftEndTime)}
          key={initialValues.giftEndTime}
          onChange={onEndGiftChange}
          helperText={
            !!errors?.giftEndTime && touched.giftEndTime
              ? errors?.giftEndTime
              : ''
          }
          label="Ngày kết thúc quà tặng"
        />
      </Grid>
      <Grid item xs={12}>
        <TextField
          key={initialValues?.updatedUser}
          defaultValue={initialValues?.updatedUser}
          onChange={handleChange}
          onBlur={handleBlur}
          error={!!errors.updatedUser && touched.updatedUser}
          helperText={
            !!errors.updatedUser && touched.updatedUser
              ? errors.updatedUser
              : ''
          }
          name="updatedUser"
          label="Người cập nhật"
        />
      </Grid>
      <Grid container gap={2} mt={2} ml={2}>
        <Button
          disabled={isSubmiting}
          width={100}
          color="inherit"
          onClick={onBack}
        >
          Back
        </Button>
        <Button loading={isSubmiting} width={100} onClick={submitForm}>
          Edit
        </Button>
      </Grid>
    </Grid>
  )
}

export default EditForm
